var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglePlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 41,
    viewBox: "0 0 140 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.91 40.5H5.70511C2.88588 40.5 0.576904 38.2488 0.576904 35.5V5.5C0.576904 2.75125 2.88588 0.500002 5.70511 0.500002H133.91C136.729 0.500002 139.038 2.75125 139.038 5.5V35.5C139.038 38.2488 136.729 40.5 133.91 40.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133.91 1.30125C136.285 1.30125 138.217 3.185 138.217 5.5V35.5C138.217 37.815 136.285 39.6988 133.91 39.6988H5.70511C3.33075 39.6988 1.3987 37.815 1.3987 35.5V5.5C1.3987 3.185 3.33075 1.30125 5.70511 1.30125H133.91ZM133.91 0.500002H5.70511C2.88588 0.500002 0.576904 2.75125 0.576904 5.5V35.5C0.576904 38.2488 2.88588 40.5 5.70511 40.5H133.91C136.729 40.5 139.038 38.2488 139.038 35.5V5.5C139.038 2.75125 136.729 0.500002 133.91 0.500002Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2796 8.03869C10.9783 8.34619 10.804 8.82494 10.804 9.44494V31.5599C10.804 32.1799 10.9783 32.6587 11.2796 32.9662L11.354 33.0337L24.0642 20.6462V20.3537L11.354 7.96619L11.2796 8.03869Z",
    fill: "url(#paint0_linear_7780_55697)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2963 24.7775L24.0642 20.6462V20.3537L28.3014 16.2225L28.3963 16.2762L33.4142 19.06C34.8463 19.85 34.8463 21.15 33.4142 21.945L28.3963 24.7237L28.2963 24.7775Z",
    fill: "url(#paint1_linear_7780_55697)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3962 24.7237L24.0642 20.5L11.2795 32.9662C11.7552 33.4537 12.5308 33.5125 13.4129 33.025L28.3962 24.7237Z",
    fill: "url(#paint2_linear_7780_55697)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3962 16.2763L13.4129 7.975C12.5308 7.4925 11.7552 7.55125 11.2795 8.03875L24.0642 20.5L28.3962 16.2763Z",
    fill: "url(#paint3_linear_7780_55697)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2103 10.7437C49.2103 11.5787 48.9539 12.2475 48.4487 12.7462C47.868 13.3375 47.1115 13.635 46.1846 13.635C45.2987 13.635 44.5423 13.3325 43.9218 12.7362C43.3 12.1312 42.9897 11.3887 42.9897 10.5C42.9897 9.61124 43.3 8.86874 43.9218 8.26874C44.5423 7.66749 45.2987 7.36499 46.1846 7.36499C46.6256 7.36499 47.0462 7.45374 47.4474 7.61874C47.8474 7.78499 48.1731 8.00999 48.409 8.28749L47.8731 8.81499C47.4615 8.34124 46.9013 8.10749 46.1846 8.10749C45.5385 8.10749 44.9782 8.32749 44.5026 8.77124C44.0321 9.21624 43.7962 9.79249 43.7962 10.5C43.7962 11.2075 44.0321 11.7887 44.5026 12.2337C44.9782 12.6725 45.5385 12.8975 46.1846 12.8975C46.8705 12.8975 47.4474 12.6725 47.9026 12.2287C48.2026 11.935 48.3731 11.53 48.418 11.0125H46.1846V10.29H49.1641C49.2 10.4462 49.2103 10.5975 49.2103 10.7437Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9372 8.23881H51.1385V10.1388H53.6616V10.8613H51.1385V12.7613H53.9372V13.4976H50.3462V7.50256H53.9372V8.23881Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2731 13.4976H56.4808V8.23881H54.7642V7.50256H58.9911V8.23881H57.2731V13.4976Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62.05 13.4976V7.50256H62.8411V13.4976H62.05Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3473 13.4976H65.5615V8.23881H63.8384V7.50256H68.0704V8.23881H66.3473V13.4976Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M76.073 12.7262C75.4666 13.3325 74.7153 13.635 73.8192 13.635C72.9179 13.635 72.1666 13.3325 71.5602 12.7262C70.9551 12.1212 70.6538 11.3787 70.6538 10.5C70.6538 9.62124 70.9551 8.87874 71.5602 8.27374C72.1666 7.66749 72.9179 7.36499 73.8192 7.36499C74.7102 7.36499 75.4615 7.66749 76.0679 8.27874C76.6782 8.88874 76.9795 9.62624 76.9795 10.5C76.9795 11.3787 76.6782 12.1212 76.073 12.7262ZM72.1461 12.2237C72.6025 12.6725 73.1577 12.8975 73.8192 12.8975C74.4756 12.8975 75.0359 12.6725 75.4871 12.2237C75.9423 11.775 76.173 11.1987 76.173 10.5C76.173 9.80124 75.9423 9.22499 75.4871 8.77624C75.0359 8.32749 74.4756 8.10249 73.8192 8.10249C73.1577 8.10249 72.6025 8.32749 72.1461 8.77624C71.691 9.22499 71.4602 9.80124 71.4602 10.5C71.4602 11.1987 71.691 11.775 72.1461 12.2237Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0911 13.4976V7.50256H79.0526L82.0423 12.1651H82.077L82.0423 11.0126V7.50256H82.8334V13.4976H82.0077L78.877 8.60506H78.8423L78.877 9.76256V13.4976H78.0911Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4589 22.2525C68.0499 22.2525 66.082 24.04 66.082 26.5063C66.082 28.9525 68.0499 30.7588 70.4589 30.7588C72.873 30.7588 74.841 28.9525 74.841 26.5063C74.841 24.04 72.873 22.2525 70.4589 22.2525ZM70.4589 29.0838C69.1371 29.0838 67.9999 28.02 67.9999 26.5063C67.9999 24.9725 69.1371 23.9275 70.4589 23.9275C71.7807 23.9275 72.923 24.9725 72.923 26.5063C72.923 28.02 71.7807 29.0838 70.4589 29.0838ZM60.9089 22.2525C58.4948 22.2525 56.532 24.04 56.532 26.5063C56.532 28.9525 58.4948 30.7588 60.9089 30.7588C63.3217 30.7588 65.2858 28.9525 65.2858 26.5063C65.2858 24.04 63.3217 22.2525 60.9089 22.2525ZM60.9089 29.0838C59.5858 29.0838 58.4448 28.02 58.4448 26.5063C58.4448 24.9725 59.5858 23.9275 60.9089 23.9275C62.2307 23.9275 63.3679 24.9725 63.3679 26.5063C63.3679 28.02 62.2307 29.0838 60.9089 29.0838ZM49.5448 23.5563V25.3638H53.9717C53.8423 26.3738 53.4961 27.1163 52.9653 27.6338C52.3192 28.2588 51.3128 28.9525 49.5448 28.9525C46.8205 28.9525 44.6871 26.8088 44.6871 24.1525C44.6871 21.4963 46.8205 19.3525 49.5448 19.3525C51.0179 19.3525 52.0897 19.9138 52.8807 20.6413L54.1871 19.3675C53.0807 18.3375 51.6089 17.5463 49.5448 17.5463C45.8089 17.5463 42.6692 20.51 42.6692 24.1525C42.6692 27.795 45.8089 30.7588 49.5448 30.7588C51.5641 30.7588 53.0807 30.1138 54.273 28.9038C55.4948 27.7125 55.8756 26.0375 55.8756 24.685C55.8756 24.265 55.8397 23.8788 55.7756 23.5563H49.5448ZM96.014 24.9575C95.6538 24.0063 94.5422 22.2525 92.2781 22.2525C90.0346 22.2525 88.1666 23.9763 88.1666 26.5063C88.1666 28.8888 90.0153 30.7588 92.4935 30.7588C94.4974 30.7588 95.6538 29.5675 96.1294 28.8738L94.6423 27.9075C94.1461 28.615 93.4705 29.0838 92.4935 29.0838C91.523 29.0838 90.8269 28.65 90.3807 27.795L96.2153 25.4413L96.014 24.9575ZM90.0653 26.3738C90.0153 24.7338 91.3717 23.8938 92.3435 23.8938C93.1051 23.8938 93.7512 24.265 93.9666 24.7963L90.0653 26.3738ZM85.323 30.5H87.241V18H85.323V30.5ZM82.182 23.2H82.1179C81.6871 22.7025 80.8653 22.2525 79.8243 22.2525C77.6397 22.2525 75.6423 24.1225 75.6423 26.52C75.6423 28.9038 77.6397 30.7588 79.8243 30.7588C80.8653 30.7588 81.6871 30.305 82.1179 29.7925H82.182V30.4025C82.182 32.0288 81.291 32.9025 79.8538 32.9025C78.682 32.9025 77.9551 32.0775 77.6551 31.3838L75.9871 32.0625C76.4679 33.19 77.741 34.5775 79.8538 34.5775C82.1025 34.5775 83.9999 33.2875 83.9999 30.1488V22.5113H82.182V23.2ZM79.9884 29.0838C78.6666 29.0838 77.5602 28.005 77.5602 26.52C77.5602 25.0213 78.6666 23.9275 79.9884 23.9275C81.291 23.9275 82.3179 25.0213 82.3179 26.52C82.3179 28.005 81.291 29.0838 79.9884 29.0838ZM104.994 18H100.406V30.5H102.319V25.7638H104.994C107.118 25.7638 109.201 24.265 109.201 21.8813C109.201 19.4988 107.113 18 104.994 18ZM105.044 24.025H102.319V19.7388H105.044C106.472 19.7388 107.287 20.895 107.287 21.8813C107.287 22.8488 106.472 24.025 105.044 24.025ZM116.868 22.2288C115.486 22.2288 114.049 22.8238 113.458 24.1425L115.155 24.8363C115.52 24.1425 116.192 23.9175 116.903 23.9175C117.895 23.9175 118.901 24.4988 118.917 25.525V25.6563C118.57 25.4613 117.829 25.1725 116.918 25.1725C115.09 25.1725 113.227 26.1538 113.227 27.985C113.227 29.66 114.724 30.7388 116.408 30.7388C117.695 30.7388 118.405 30.1725 118.851 29.5138H118.917V30.48H120.764V25.685C120.764 23.4688 119.067 22.2288 116.868 22.2288ZM116.637 29.0788C116.011 29.0788 115.14 28.7763 115.14 28.02C115.14 27.0525 116.227 26.6813 117.168 26.6813C118.01 26.6813 118.405 26.8625 118.917 27.1013C118.767 28.2588 117.745 29.0788 116.637 29.0788ZM127.495 22.5025L125.296 27.9213H125.231L122.958 22.5025H120.895L124.31 30.075L122.361 34.2888H124.36L129.623 22.5025H127.495ZM110.252 30.5H112.17V18H110.252V30.5Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7780_55697",
    x1: 22.9357,
    y1: 31.7902,
    x2: 6.15867,
    y2: 14.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7780_55697",
    x1: 35.279,
    y1: 20.4986,
    x2: 10.4616,
    y2: 20.4986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7780_55697",
    x1: 26.0406,
    y1: 18.2039,
    x2: 3.28956,
    y2: -5.13049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7780_55697",
    x1: 8.06139,
    y1: 40.3238,
    x2: 18.2207,
    y2: 29.9041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayIcon);
export default __webpack_public_path__ + "static/media/google-play-icon.0e4eb89962f3f8e5ebb0104a8b62cbfc.svg";
export { ForwardRef as ReactComponent };